import React, {useState, useEffect, useCallback} from "react";
import {useDropzone} from 'react-dropzone'

import { OBJECT_EMPTY, GET_TOKEN, ARRAY_EMPTY } from "../../../helpers";
import { 
  API_URL, 
  GET_ADMIN_RECEIVED_FILES, 
  POST_ADMIN_FILE_UPLOAD, 
  GET_ADMIN_IMPORT_FILE_STATUS, 
  GET_ADMIN_IMPORT_FILE, 
  GET_ADMIN_IMPORTED_FILES,
  GET_ADMIN_EXPORTED_FILES, 
  GET_DOWNLOAD_FILE, 
  POST_ADMIN_IMPORT_FILE_STATE_ACTION } from "../../../constants";
import { Modal } from "../../Global/Modal/Modal";

import { SelectInput } from "../../../components/Global/SelectInput/SelectInput";
import { LoadingSpinner } from "../../../components/dashboard/partials/LoadingSpinner";
import { SmallSpinner } from "../../../components/dashboard/partials/SmallSpinner";
import { ReactTable } from "../../../components/Global/ReactTable/ReactTable";
import { EmptyData } from "../../Global/EmptyData/EmptyData";

import csvImg from "../../../images/CSV.png";
import anyImg from "../../../images/ANY.png";


import "./FileImportTable.css";

export const FileImportTable = () => {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [importedDataLoaded, setImportedDataLoaded] = useState(false);
  const [reportsDataLoaded, setReportsDataLoaded] = useState(false);
  const [selectedTab, setSelectedTab] = useState(parseInt(sessionStorage.getItem("selectedTab")) || 0);
  const [fileToSubmit, setFileToSubmit] = useState([]);
  
  const [fileIsBeingUploaded, setFileIsBeingUploaded] = useState(false);
  
  const [selectedModalTab, setSelectedModalTab] = useState(0);
  const [fileUploadModal, setFileUploadModal] = useState(false);
  const [removeFileModal, setRemoveFileModal] = useState(false);
  const [removeFileModalInfo, setRemoveFileModalInfo] = useState({});

  const [receivedFiles, setReceivedFiles] = useState([]);
  const [importedFiles, setImportedFiles] = useState([]);
  const [reportedFiles, setReportedFiles] = useState([]);
  const [fileUploadStatusContent, setFileUploadStatusContent] = useState({});
  const [fileUploadError, setFileUploadError] = useState('');
  const [reloadTable, setReloadTable] = useState(false);

  const [badFiles, setBadFiles] = useState([])

  const controller = new AbortController()
  const signal = controller.signal
  const statusToHaveRowActions = 'confirmed'
  // const statusToHaveRowActions = 'uploaded_admin'

  function MyDropzone() {
    const onDrop = useCallback(acceptedFiles => {
      setFileToSubmit([...fileToSubmit, ...acceptedFiles])
    }, [])
    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})
  
    return (
      <div className="modal__file_upload__dropzone" {...getRootProps()}>
        <input {...getInputProps()} accept=".csv"/>
        {
          isDragActive
            ? <p>Drop the files here ...</p> 
            : <>
                <h2>Drag a file here</h2>
                <h5>or if you prefer ...</h5>
                <div className="default_button">Select files from device</div>
              </>
        }
      </div>
    )
  }

  const fetchTableData = () => {
    sessionStorage.setItem("selectedTab", selectedTab);

    setDataLoaded(false)
    setImportedDataLoaded(false)
    setReportsDataLoaded(false)
    setReceivedFiles([])
    setImportedFiles([])


    if (selectedTab === 0) {
      // abortFetching()
      fetch(API_URL + GET_ADMIN_RECEIVED_FILES, {
        method: "get",
        signal,
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + GET_TOKEN(), //TODO - remove bearier, add to GET_TOKEN()
        }),
      })
        .then(res => res.json())
        .then((res) => {
          setReceivedFiles(res)
          setDataLoaded(true)
        })
        .catch((err) => {
          console.log(err.response)
          setDataLoaded(true)
        })
    } 
    
    else if (selectedTab === 3) {
      fetch(API_URL + GET_ADMIN_IMPORTED_FILES, {
        method: "get",
        signal,
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + GET_TOKEN(), //TODO - remove bearier, add to GET_TOKEN()
        }),
      })
        .then(res => res.json())
        .then((res) => {
          setImportedFiles(res)
        })
        .catch((err) => {
          console.log(err.response)
        })
        .finally(() => setImportedDataLoaded(true))
    }

    else if (selectedTab === 4) {

      // setReportsDataLoaded(true)
      fetch(API_URL + GET_ADMIN_EXPORTED_FILES, {
        method: "get",
        signal,
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + GET_TOKEN(), //TODO - remove bearier, add to GET_TOKEN()
        }),
      })
        .then(res => res.json())
        .then((res) => {
          setReportedFiles(res)
        })
        .catch((err) => {
          console.log(err.response)
        })
        .finally(() => setReportsDataLoaded(true))
    }
  }


  // On component load, initiate the check
    // if received "fileUploadStatusContent".length > 0 
      // repeat after 5 seconds
    // else let user to upload file

  // when file submited and response received call the check
    // if received "fileUploadStatusContent".length > 0 
      // repeat after 5 seconds
    // else let user to upload file

  useEffect(() => {
    setFileToSubmit([])
    setFileUploadError('')
  }, [selectedModalTab, fileUploadModal])

  // Get Files that are being uploaded
  useEffect(() => {
    if (fileUploadStatusContent.status === "inProgress") {
      let fetchReccuringInfo = setInterval(() => fetchUploadStatus(), 5000);
      setFileIsBeingUploaded(true)

      return () => clearInterval(fetchReccuringInfo)
    }

    else {
      setFileIsBeingUploaded(false)
    }
  })
  // Set Current table tab
  useEffect(() => {
    // TODO: check how nicely abort fetch on selectedTabChange

    fetchTableData()
  }, [selectedTab, reloadTable])

  const submitFiles = () => {
    setFileUploadError('')

    if (!ARRAY_EMPTY(fileToSubmit)) {
      const formData = new FormData();
      let error = false;

      Array.from(fileToSubmit).forEach((file, index) => { 
        if (file.name?.toLowerCase().includes('.csv')) {
          return formData.append(`file[${index}]`, file) 
        } else {

          error = true
          setBadFiles(file.name)
          return setFileUploadError('Wrong file format')
        }
      });

      if (!error) {
        setFileIsBeingUploaded(false);
  
        fetch(API_URL + POST_ADMIN_FILE_UPLOAD + `?type=${selectedModalTab === 0 ? 'sale' : 'purchase'}`, {
          method: "POST",
          body: formData,
          headers: new Headers({
            Authorization: "Bearer " + GET_TOKEN(),
          })
        })
          .then(result => {
            if (result.status === 200 || result.status === 201) {

              setFileToSubmit([])
              setFileUploadModal(false)
              fetchTableData()
            }
          })
          .catch(error => {
            console.error('Error:', error);
            setFileUploadError(error)
          })
      };
    }
  }

  const fetchUploadStatus = () => {
    fetch(API_URL + GET_ADMIN_IMPORT_FILE_STATUS, {
      method: "get",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        setFileUploadStatusContent(response)
      })
      .finally(() => {
        setDataLoaded(true)
      })
  }

  const submitImportedFilesStatus = (status, fileID) => {
    fetch(API_URL + POST_ADMIN_IMPORT_FILE_STATE_ACTION + fileID, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
      body: JSON.stringify({status}),
    })
      .then(() => fetchTableData())
      .catch(err => console.log(err))
  }

  const getFileBlob = (link, fileName) => {
    fetch(API_URL + GET_DOWNLOAD_FILE + link, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then(res => res.blob())
      .then(blob => {
        let file = window.URL.createObjectURL(blob);
        let a = document.createElement('a');

        a.setAttribute("id", "temprorary_CVS_link");
        document.body.appendChild(a);
        
        if (!window.navigator.msSaveOrOpenBlob) {
          a.href = file;
          a.download = fileName ? fileName : 'stopvat.csv';
        }

        document.getElementById('temprorary_CVS_link').click()
      }).then(() => document.getElementById('temprorary_CVS_link').remove())
      .catch(err => console.log(err));
  }

  const ReceivedFilesConstructor = () => {
    const ReceivedFilesTableColumns = [
      {
        Header: "Date & time",
        accessor: "created_at",
        className: "cell_date"
      },
      {
        Header: "File name",
        accessor: "name",
        className: "cell_name",
        Cell: (cell) => {

          return <div className="cell_name_wrapper">
            {cell.data[cell.row.id].file_type === 'csv'
              ? <img src={csvImg} alt="file_type"/>
              : <img src={anyImg} alt="file_type"/>}

            {cell.value}
          </div>
        }
      },
      {
        Header: "Related Returns",
        accessor: "note",
        className: "return_countries",
        Cell: (cell) => {
          const countries = cell.data[cell.row.id].return_countries

          return <div className="return_countries_wrapper">
            {
              countries.map((item, i) => {
                return <div className="return_item" key={item.id ? item.id : item.period +  i + cell.row.id}>
                  <img src={item.country.img} className="flag-icon-img" alt='return' />
                  {item.period}
                </div>
              })
            }
          </div>
        },
      },
      {
        accessor: "file_path",
        className: "cell_download",
        Cell: (cell) => {
          return <button className='download_button' onClick={() => getFileBlob(cell.value, cell.data[cell.row.id].name)} />
        },
      },
    ];

    const ReceivedFilesList = () => {
      return <ReactTable className="ReceivedFilesListTable" columns={ReceivedFilesTableColumns} data={receivedFiles} />
    }

    return dataLoaded 
      ? receivedFiles.length > 0 ? ReceivedFilesList() : <EmptyData title='You don’t have any received files'/>
      : <LoadingSpinner/>
    
  }

  const removeItem = (id, index) => {
    let temp_array = importedFiles;

    temp_array.splice(index, 1);

    setImportedFiles([...temp_array])


    fetch(API_URL + GET_ADMIN_IMPORTED_FILES + `/${id}`, {
      method: "DELETE",
      headers: new Headers({
        Authorization: "Bearer " + GET_TOKEN(),
      })
    })
      .catch(error => {
        console.error('Error:', error);
      })
  }

  const removeReportFile = (id) => {
    fetch(API_URL + GET_ADMIN_EXPORTED_FILES + '/' + id + '/cancel', {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .catch(err => console.log(err))
      .finally(() => fetchTableData())
  }

  const moveItem = (id, index, action_type, allRows) => {
    Array.prototype.move = function(from, to) {
      this.splice(to, 0, this.splice(from, 1)[0]);
    };

    let temp_array = importedFiles;
    temp_array.move(index, action_type === 'up' ? parseInt(index) - 1 : parseInt(index) + 1);

    let filteredRows = allRows.filter(row => row.status === statusToHaveRowActions)
    let originalItem = filteredRows.filter(item => item.id === id)


    if (action_type === 'up') {
      const iterationArray = [filteredRows[filteredRows.indexOf(...originalItem)], filteredRows[filteredRows.indexOf(...originalItem) + 1]];

      iterationArray.map(item => {
        if (item?.id) {
          fetch(API_URL + GET_ADMIN_IMPORTED_FILES + `/${item.id}`, {
            method: "POST",
            body: JSON.stringify({
              order_num: item.id === id ? parseInt(index) - 1 : parseInt(index)
            }),
            headers: new Headers({
              "Content-Type": "application/json",
              Authorization: "Bearer " + GET_TOKEN(),
            })
          })
            .catch(error => {
              console.error('Error:', error);
            })
        }
      })


      

    } 
    else { 
      const iterationArray = [filteredRows[filteredRows.indexOf(...originalItem)], filteredRows[filteredRows.indexOf(...originalItem) + 1]];

      iterationArray.map(item => {
        if (item?.id) {
          fetch(API_URL + GET_ADMIN_IMPORTED_FILES + `/${item.id}`, {
            method: "POST",
            body: JSON.stringify({
              order_num: item.id === id ? parseInt(index) + 1 : parseInt(index)
            }),
            headers: new Headers({
              "Content-Type": "application/json",
              Authorization: "Bearer " + GET_TOKEN(),
            })
          })
            .catch(error => {
              console.error('Error:', error);
            })
        }
      })
    }


    setImportedFiles([...temp_array])
  }

  const moveArrow = (itemId, rowId, allRows) => {
    let arrowUp = importedFiles[rowId - 1]?.status === statusToHaveRowActions;
    let arrowDown = importedFiles[rowId + 1]?.status === statusToHaveRowActions;

    return <>
      {arrowUp   && <div className="arrow_up"   onClick={() => moveItem(itemId, rowId, 'up', allRows)  }/>}
      {arrowDown && <div className="arrow_down" onClick={() => moveItem(itemId, rowId, 'down', allRows)}/>}
    </>
  }

  const ImportedFiles = () => {
    const SelectBox = (fileID) => {
      const selectValues = [
        {
          label: "Approve",
          value: 'confirmed'
        },
        {
          label: "Reject",
          value: 'rejected'
        },
      ]

      return <SelectInput 
        selectValues={selectValues}
        inputValueHandler={(e) => {
          submitImportedFilesStatus(e.value, fileID);
        }}
        // placeholder='Select...'
      />
    }

    const generateStatus = (status, cellData) => {
      // <div className="dot green"/> 
      // <div className="dot blue"/> 
      // <div className="dot red"/> 
      // <div className="dot gray"/> 
      
      switch (status) {
        case 'uploaded': {
          return <>
            <div className="dot green"/>
            Imported
          </>
        }

        case 'initial_checking': {
          return <>
            <SmallSpinner />
            {/* <div className="dot blue"/>  */}
            Checking file format
          </>
        }

        case 'uploaded_admin': {
          return <>
            <div className="dot green"/>
            Imported
          </>
        }

        case 'processed': {
          return <>
           
          </>
        }

        case 'updated': {
          return <>
            <div className="dot gray"/> 
            Waiting for approval
          </>
        }

        case 'processing': {
          return <>
            <SmallSpinner />
            {/* <div className="dot blue"/>  */}
            Processing 
          </>
        }

        case 'confirmed': {
          return <>
            <div className="dot gray"/> 
            Waiting in a queue
          </>
        }

        case 'in_progress': {
          return <>
            <SmallSpinner />
            {/* <div className="dot blue"/>  */}
            Importing
          </>
        }

        case 'rejected': {
          return <>
            <div className="dot red"/> 
            Rejected
          </>
        }

        case 'corrupted': {
          return <>
            <div className="dot red"/> 
            Corrupted
          </>
        }

        case 'declined': {
          return <>
            <div className="dot red"/> 
            Declined
          </>
        }

        case 'imported_admin': {
          return <> 
            <SmallSpinner />
            {/* <div className="dot green"/>  */}
            Importing
          </>
        }

        case 'uploaded_admin': {
          return <> 
            {/* <SmallSpinner /> */}
            <div className="dot green"/> 
            Imported
          </>
        }

        default: {
          return <>
            <div className="dot gray"/> 
            {status}
          </>
        }
      }
    }

    const ImportedFilesTableColumns = [
      {
        Header: "Import date",
        accessor: "created_at",
        className: "cell_date",
        Cell: (cell) => {
          return <div className="created_at__content">
            {cell.value}

            {/* commented for upload. remove comment later */ }
            {cell.row.original.status === statusToHaveRowActions && 
              <button className="remove" onClick={() => {
                setRemoveFileModalInfo({...cell.row.original, index: cell.row.id})
                setRemoveFileModal(true)
              }} />
            }
          </div>
        }
      },
      {
        Header: "File name",
        accessor: "name",
        className: "cell_name",
        Cell: (cell) => {
          return <div className="cell_name__content flex-align-center">
            {cell.value}

            {cell.row.original.status === statusToHaveRowActions && (
              <div className="arrow">
                {moveArrow(cell.row.original.id, cell.row.index, cell.data)}
              </div>
            )}
          </div>
        }
      },
      {
        accessor: "file_path",
        className: "cell_download",
        Cell: (cell) => {
          // name
          const file_name = cell.data[cell.row.id].name
          return <button className='download_button' onClick={() => getFileBlob(cell.value, file_name)}/>
        },
      },
      {
        Header: "Number of entries",
        accessor: "numberEntities",
        className: "cell_entries"
      },
      {
        Header: "Number of Errors",
        accessor: "numberOfErrors",
        className: "cell_errors",
      },
      {
        accessor: "error_file_path",
        className: "cell_download",
        Cell: (cell) => {

          const error_file_path = cell.value 
          const error_full_file_path = cell.data[cell.row.id].error_full_file_path

          const error_file_name = cell.data[cell.row.id].error_file_name 
          const error_full_file_name = cell.data[cell.row.id].error_full_file_name

          
          if (error_full_file_path !== null && error_full_file_path !== undefined) {
            return <button 
              className='download_button' 
              onClick={() => 
                getFileBlob(error_full_file_path , error_full_file_name )
              }/>
          } 

          else if (error_file_path !== null && error_file_path !== undefined) {
            return <button 
              className='download_button' 
              onClick={() => 
                getFileBlob(error_file_path , error_file_name )
              }/>
          } 
          
          else {
            return  <></>
          }
        },
      },
      {
        accessor: "action",
        className: "cell_selectAction",
        Cell: (cell) => {
            // Action dropdown
            let approval_status = cell.data[cell.row.id].status
            let fileId = cell.data[cell.row.id].id

            return (
              approval_status === 'processed'
                ? SelectBox(fileId)
                : <div className={`status ${approval_status}`}>
                    {generateStatus(approval_status, cell.row.original)}
                  </div>
            )
        },
      },
    ];

    const ImportedFilesList = () => {
      return <ReactTable className="ImportedFilesListTable" columns={ImportedFilesTableColumns} data={importedFiles} />
    }

    return importedDataLoaded 
      ? importedFiles.length > 0 ? ImportedFilesList() : <EmptyData title='You don’t have any imported files'/>
      : <LoadingSpinner/>
    
  }

  const ReportFiles = () => {
    const ReportFilesTableColumns = [
      {
        Header: "Date & Time",
        accessor: "created_at",
        className: "cell_date",
        Cell: (cell) => 
          <div className="flex">

            {cell.row.original.status == 'processing' && 
              <button 
                className="remove"
                onClick={() => removeReportFile(cell.row.original.id)}
              />
            }

            {cell.value}
          </div>
      },
      {
        Header: "Report type",
        accessor: "type",
        className: "cell_type",
      },
      {
        Header: "Period from",
        accessor: "from",
        className: "cell_period_from",
      },
      {
        Header: "Period to",
        accessor: "to",
        className: "cell_period_to",
      },
      {
        Header: "Download",
        accessor: "file_path",
        className: "cell_download",
        Cell: (cell) => {
          const fileInfo = cell.value
          // status
          
          if ( cell.row.original.status == 'processing') {
            return <div className="flex flex-align-center">
              <SmallSpinner />
              <p>In progress</p>
            </div>
          } else {
             return <button className='download_button' onClick={() => getFileBlob(cell.value, cell.data[cell.row.id].name)} />
          }
        }
      },
    ];

    // reportsDataLoaded
    // <EmptyData title='You don’t have any reports'/>
    // return <ReactTable className="ReportFilesListTable Reports" columns={ReportFilesTableColumns} data={reportedFiles} />


    return reportsDataLoaded 
      ? reportedFiles.length > 0 ? <ReactTable className="ReportFilesListTable Reports" columns={ReportFilesTableColumns} data={reportedFiles} /> : <EmptyData title='You don’t have any reports'/>
      : <LoadingSpinner/>
  }

  const currentFileTableViewconstructor = () => {
    switch (selectedTab) {
      case 0: {
        return <ReceivedFilesConstructor />
      }

      // case 1: {
      //   return <ImportFile />
      // }

      // case 2: {
      //   return <ImportFile />
      // }

      case 3: {
        return <ImportedFiles />
      }

      case 4: {
        return <ReportFiles />
      }

      default: {
        return <>Whoops, you should not be here. Try refreshing page?</>
      }
    }
  }

  return (
    <div className="FileImportTable">

      <ul className="FileImportTable__tabs">
        <li> <button onClick={() => setSelectedTab(4)} className={ selectedTab === 4 ? 'active' : '' }>Reports</button></li>
        <li> <button onClick={() => setSelectedTab(0)} className={ selectedTab === 0 ? 'active' : '' }>Received files</button></li>
        {/* <li> <button onClick={() => setSelectedTab(1)} className={ selectedTab === 1 ? 'active' : '' }>Import sales</button></li>
            <li> <button onClick={() => setSelectedTab(2)} className={ selectedTab === 2 ? 'active' : '' }>Import purchases</button></li> */}
        <li> <button onClick={() => setSelectedTab(3)} className={ selectedTab === 3 ? 'active' : '' }>Imported files</button></li>

        <div className="FileImportTable__import_files button__add-new" onClick={() => setFileUploadModal(true)}></div>
      </ul>

      {(dataLoaded || importedDataLoaded || reportsDataLoaded)
        ? currentFileTableViewconstructor()
        : <LoadingSpinner/>}

      <Modal
        ModalOpenHandler={setFileUploadModal}
        ModalOpen={fileUploadModal}
        customClassName={'modal__file_upload'}
      >
        <ul className="modal__file_upload__tablist">
          <li className={selectedModalTab === 0 ? 'active' : ''} onClick={() => setSelectedModalTab(0)}>Import sales</li>
          <li className={selectedModalTab === 1 ? 'active' : ''}  onClick={() => setSelectedModalTab(1)}>Import purchases</li>
          
          {fileUploadError.length > 0 && (
            <div className="error_message">Error: {fileUploadError}</div>
          )}
        </ul>

        <MyDropzone/>

        <ul className="modal__file_upload__filelist">
          {fileToSubmit.map((item, index) => {
            return (
              <li key={item.name + index} className={badFiles.indexOf(item.name) > -1 ? 'bad-file' : '' }>
                <div className={` file_icon_wrapper`}>
                  <div 
                    className="file_remove" 
                    onClick={() => {
                      let oldArray = fileToSubmit;
                          oldArray.splice(index, 1)

                      setFileToSubmit([...oldArray])
                    }}
                  />
                  <div className="file_icon icon"></div>
                </div>

                <p className="file_name">
                  {item.name}
                </p>
              </li>
            )
          })}

          <button 
            type="button"
            className='default_button upload'
            onClick={(e) => {
              e.preventDefault()
              submitFiles()
            }}
            disabled={fileToSubmit.length == 0}
          >
            Import files
          </button>
      </ul>
      </Modal>


      <Modal
        ModalOpenHandler={setRemoveFileModal}
        ModalOpen={removeFileModal}
        customClassName={'modal__remove_upload'}
        title={'Remove file'}
        closeButton={true}
      >
      
        <h4>
          Remove <u>{removeFileModalInfo.name}</u>?
        </h4>
        
        <div className="Modal__submit-wrapper">
          <button 
            onClick={() => {
              setRemoveFileModal(false)
              removeItem(removeFileModalInfo.id, removeFileModalInfo.index)}}
          >
            Remove
          </button>
        </div>

      </Modal>
    </div>
  );
};
